import { VideoKeyFields } from '@symplbe/sympl-components';
import { WithPlaceholder } from 'types/careers-page/section';
import { getSectionHeaderDefaultConfig } from '../shared/defaultConfig';

export const defaultVideoSettings: VideoKeyFields & WithPlaceholder = {
  ...getSectionHeaderDefaultConfig(),
  video: '', // TODO: add default video or fix editable field
};
